import { render, staticRenderFns } from "./UsersIndex.vue?vue&type=template&id=3b5fb20e&scoped=true&"
import script from "./UsersIndex.vue?vue&type=script&lang=js&"
export * from "./UsersIndex.vue?vue&type=script&lang=js&"
import style0 from "./UsersIndex.vue?vue&type=style&index=0&id=3b5fb20e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5fb20e",
  null
  
)

export default component.exports